module.exports = __webpack_public_path__ + "img/8-1.16a60d09.png";